// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container__UcIhT","row":"style__row__3Ij_h","general":"style__general__1KUND","delete":"style__delete__28InZ","collaborators_section":"style__collaborators_section__1IVK6","totalCollabs":"style__totalCollabs__37Hdj","form":"style__form__2TLDj","collaborator":"style__collaborator__1UR3L","remove":"style__remove__1w7fQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/account_page/settings/style.scss
// module id = 456
// module chunks = 0